"use client";

import AllModals from "../components/modals/_AllModals";
import Header from "../components/header/Header";

export default function WelcomePage() {
  return (
    <>
      <Header isWelcomePage={true} displayViewHomepageButton={true} />
      <AllModals />
    </>
  );
}
